var path = 'areas/projects/actions/Octopus.Script_summary.html';
var html = "<div ng-switch on='properties[\"Octopus.Action.RunOnServer\"]'> <p ng-switch-when=true> Run a script on the Octopus Server <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> <p ng-switch-default=\"\"> Run a script <span ng-show=isSingleStep>across targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.Script_summary.html
// module id = 850
// module chunks = 1